/**************************************************
 * Nombre:       ListaFunnels
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import Tarjeta_Funnel from "../../Tarjetas/Tarjeta_Funnel";
import {usuarioContext} from "../../../App";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {ESTADOSCAMPANAS} from "../../../Constantes";

const ListaFunnels = ({realizado, cargar}) => {
    const cData = useContext(usuarioContext)
    const [funnels, setFunnels] = useState([]);
    const [campanas, setCampanas] = useState([]);


    const obtenerFunnels = async (idUsuario) => {

        let wFunnels = [where('estado', '==', 'Publicado')]
        let doxFunnels = await obtenerColWheres({col: 'funnels', wheres: wFunnels})
        let funnelsPublicos = doxFunnels.data
        setFunnels(funnelsPublicos)

        let wCampanas = [where('idUsuario', '==', idUsuario),
            where('estado', 'in', [ESTADOSCAMPANAS[0].nombre, ESTADOSCAMPANAS[1].nombre])]
        let doxCampanas = await obtenerColWheres({col: 'campanas', wheres: wCampanas})
        let campanas = doxCampanas.data
        setCampanas(campanas)


    }

    useEffect(() => {


        let idUsuario = cData.usuario.id;
        obtenerFunnels(idUsuario).then()

    }, [cData, cargar])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >



            {funnels.map((it, index) => {
                return (
                    <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                        <Tarjeta_Funnel item={it} campanas={campanas} realizado={realizado}/>
                    </Grid>
                )
            })}


        </Grid>
    )

}
export default ListaFunnels    